export const variants = `
     {
            labels {
                id
                key
                title
                value
            }
            variant {
                id
                name
                type
                key
            }
     }
`;

export const mix_variants = `
    {
        title
        keys
        custom_fields
        is_main_price
        price {
            price
            offer_price
            has_offer
            discount_percent
            offer_expireAt
            offer_startAt
            show_discount_timer
            main_price
            offer_label
            installment_gateways
        }
        details {
            product_code
            count
            limit_min
            limit_max
            limit_max_reached
        }
        labels {
            title
            id
            variant {
                key
            }
        }
        labels_obj
        
        has_media_gallery
        is_favorite
        is_notify
        media_gallery {
            alt
            url
        }
    }
`;
